import { createReducer } from '@reduxjs/toolkit';
import {
  IFacilityState,
  IFacilityStatisticsState,
  IFacilityLocationState,
  IFacilityDetailsState,
  IUpdateFacilityStatusState,
  IUpdateFacilityDocumentDateState,
  IUpdateFacilityViewStatusState,
  IFacilityShiftStaticsState,
  IAcceptRejectFacilityDocumentState,
  IFacilitySignupState,
  IFacilityTypesState,
  IFacilityTypeDocumentRequirementsState,
  IFacilityDocumentUploadState,
  IUpdateFacilityViolationFlagState,
  IFacilityUserState,
  IUpdateFacilityProfileState,
  IFacilityProfileState,
  IFacilityShiftHistoryState,
  IFacilityReportStatsState,
  IWorkerAttendanceState,
  IFacilityDashboardStatisticsState,
  IFacilityShiftStatusChartState,
  IFacilityShiftCalendarState,
  IFacilityAssignedWorkersState
} from './types';
import {
  fetchFacilityList,
  fetchFacilityStatistics,
  fetchFacilityLocations,
  fetchFacilityDetails,
  updateFacilityStatus,
  updateFacilityDocumentDates,
  fetchFacilityShiftStatics,
  acceptRejectFacilityDocument,
  facilitySignup,
  fetchFacilityTypes,
  fetchFacilityTypeDocumentRequirements,
  uploadFacilityDocument,
  updateFacilityViolationFlag,
  fetchFacilityUsers,
  updateFacilityProfile,
  fetchFacilityProfile,
  markFacilityAsViewed,
  uploadFacilityDocument2,
  fetchFacilityShiftHistory,
  fetchFacilityReportStats,
  fetchFacilityWorkerAttendance,
  fetchFacilityDashboardStatistics,
  fetchFacilityShiftStatusChart,
  fetchFacilityShiftCalendar,
  fetchFacilityAssignedWorkers
} from './actions';


const initialState: IFacilityState = {
  loading: false,
  list: {
    results: [],
    count: 0,
  },
  error: null,
};

const initialFacilityShiftStatics: IFacilityShiftStaticsState = {
  loading: false,
  data: null,
  error: null,
}

const initialFacilityStatisticsState: IFacilityStatisticsState = {
  loading: false,
  data: null,
  error: null,
};

const initialFacilityLocationState: IFacilityLocationState = {
  loading: false,
  list: {
    results: [],
    count: 0,
  },
  error: null,
};

const initialFacilityDetailsState: IFacilityDetailsState = {
  loading: false,
  data: null,
  error: null,
};

const initialFacilityDocumentDateState: IUpdateFacilityDocumentDateState = {
  loading: false,
  error: null,
}

const initialFacilityViewStatusState: IUpdateFacilityViewStatusState = {
  loading: false,
  error: null,
  message: null,
}

const initialAcceptRejectFacilityDocumentState: IAcceptRejectFacilityDocumentState = {
  loading: false,
  data: null,
  error: null,
};

const initialFacilitySignupState: IFacilitySignupState = {
  loading: false,
  data: null,
  error: null,
  selectedFacilityTypeId: undefined,
};

const initialFacilityTypesState: IFacilityTypesState = {
  loading: false,
  list: {
    results: [],
    count: 0,
  },
  error: null,
};

const initialFacilityTypeDocumentRequirementsState: IFacilityTypeDocumentRequirementsState = {
  loading: false,
  data: null,
  error: null,
};

const initialFacilityProfileState: IFacilityProfileState = {
  loading: false,
  data: null,
  error: null,
};

export const facilityProfileReducer = createReducer(initialFacilityProfileState, (builder) => {
  builder
    .addCase(fetchFacilityProfile.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchFacilityProfile.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    })
    .addCase(fetchFacilityProfile.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});


export const acceptRejectFacilityDocumentReducer = createReducer(initialAcceptRejectFacilityDocumentState, (builder) => {
  builder
    .addCase(acceptRejectFacilityDocument.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(acceptRejectFacilityDocument.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    })
    .addCase(acceptRejectFacilityDocument.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});

export const facilityShiftStaticsReducer = createReducer(initialFacilityShiftStatics, (builder) => {
  builder
    .addCase(fetchFacilityShiftStatics.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchFacilityShiftStatics.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    })
    .addCase(fetchFacilityShiftStatics.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});

export const updateFacilityViewStatusReducer = createReducer(initialFacilityViewStatusState, (builder) => {
  builder
    .addCase(markFacilityAsViewed.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.message = null;
    })
    .addCase(markFacilityAsViewed.fulfilled, (state, action) => {
      state.loading = false;
      state.message = 'Facility view status updated successfully';
    })
    .addCase(markFacilityAsViewed.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});

export const updateFacilityDocumentDateReducer = createReducer(initialFacilityDocumentDateState, (builder) => {
  builder
    .addCase(updateFacilityDocumentDates.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(updateFacilityDocumentDates.fulfilled, (state, action) => {
      state.loading = false;
    })
    .addCase(updateFacilityDocumentDates.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});

export const facilityReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(fetchFacilityList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchFacilityList.fulfilled, (state, action) => {
      state.loading = false;
      const payload = action.payload;
      if (Array.isArray(payload)) {
        state.list = { results: payload, count: payload.length };
      } else {
        state.list = payload;
      }
    })
    .addCase(fetchFacilityList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});

export const facilityStatisticsReducer = createReducer(initialFacilityStatisticsState, (builder) => {
  builder
    .addCase(fetchFacilityStatistics.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchFacilityStatistics.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    })
    .addCase(fetchFacilityStatistics.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});




export const facilityLocationsReducer = createReducer(initialFacilityLocationState, (builder) => {
  builder
    .addCase(fetchFacilityLocations.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchFacilityLocations.fulfilled, (state, action) => {
      state.loading = false;
      state.list = action.payload;
    })
    .addCase(fetchFacilityLocations.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});

export const facilityDetailsReducer = createReducer(initialFacilityDetailsState, (builder) => {
  builder
    .addCase(fetchFacilityDetails.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchFacilityDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    })
    .addCase(fetchFacilityDetails.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    })
    .addCase(acceptRejectFacilityDocument.fulfilled, (state, action) => {
      if (state.data && state.data.uploaded_documents) {
        const index = state.data.uploaded_documents.findIndex(doc => doc.document_id === action.meta.arg.documentId);
        if (index !== -1) {
          state.data.uploaded_documents[index] = {
            ...state.data.uploaded_documents[index],
            is_accepted: action.meta.arg.action === 'accept',
            is_rejected: action.meta.arg.action === 'reject',
            remarks: action.meta.arg.remarks
          };
        }
      }
    })
    .addCase(updateFacilityViolationFlag.fulfilled, (state, action) => {
      if (state.data && action.payload.data) {
        state.data.violation_flag = action.payload.data.violation_flag;
      }
    })
    .addCase(updateFacilityProfile.fulfilled, (state, action) => {
      if (state.data && action.payload.data) {
        state.data = action.payload.data;
      }
    });
});

const initialUpdateFacilityStatusState: IUpdateFacilityStatusState = {
  loading: false,
  data: null,
  error: null,
};

export const updateFacilityStatusReducer = createReducer(initialUpdateFacilityStatusState, (builder) => {
  builder
    .addCase(updateFacilityStatus.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(updateFacilityStatus.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    })
    .addCase(updateFacilityStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});

const initialUpdateFacilityProfileState: IUpdateFacilityProfileState = {
  loading: false,
  data: null,
  error: null,
};

export const updateFacilityProfileReducer = createReducer(initialUpdateFacilityProfileState, (builder) => {
  builder
    .addCase(updateFacilityProfile.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(updateFacilityProfile.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    })
    .addCase(updateFacilityProfile.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});

export const facilitySignupReducer = createReducer(initialFacilitySignupState, (builder) => {
  builder
    .addCase(facilitySignup.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(facilitySignup.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.selectedFacilityTypeId = action.payload.facility.facility_type;
    })
    .addCase(facilitySignup.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});

export const facilityTypesReducer = createReducer(initialFacilityTypesState, (builder) => {
  builder
    .addCase(fetchFacilityTypes.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchFacilityTypes.fulfilled, (state, action) => {
      state.loading = false;
      state.list = action.payload;
    })
    .addCase(fetchFacilityTypes.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});

const initialFacilityDocumentUploadState: IFacilityDocumentUploadState = {
  loading: false,
  data: null,
  error: null,
};

export const facilityDocumentUploadReducer = createReducer(initialFacilityDocumentUploadState, (builder) => {
  builder
    .addCase(uploadFacilityDocument.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(uploadFacilityDocument.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    })
    .addCase(uploadFacilityDocument.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    })
    .addCase(uploadFacilityDocument2.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(uploadFacilityDocument2.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    })
    .addCase(uploadFacilityDocument2.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});

export const facilityTypeDocumentRequirementsReducer = createReducer(initialFacilityTypeDocumentRequirementsState, (builder) => {
  builder
    .addCase(fetchFacilityTypeDocumentRequirements.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchFacilityTypeDocumentRequirements.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    })
    .addCase(fetchFacilityTypeDocumentRequirements.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});

const initialUpdateFacilityViolationFlagState: IUpdateFacilityViolationFlagState = {
  loading: false,
  data: null,
  error: null,
};

export const updateFacilityViolationFlagReducer = createReducer(initialUpdateFacilityViolationFlagState, (builder) => {
  builder
    .addCase(updateFacilityViolationFlag.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(updateFacilityViolationFlag.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload.data;
    })
    .addCase(updateFacilityViolationFlag.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});

const initialFacilityUserState: IFacilityUserState = {
  loading: false,
  list: [],
  error: null,
};

export const facilityUsersReducer = createReducer(initialFacilityUserState, (builder) => {
  builder
    .addCase(fetchFacilityUsers.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchFacilityUsers.fulfilled, (state, action) => {
      state.loading = false;
      state.list = action.payload;
    })
    .addCase(fetchFacilityUsers.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});

const initialFacilityShiftHistoryState: IFacilityShiftHistoryState = {
  loading: false,
  data: null,
  error: null,
};

export const facilityShiftHistoryReducer = createReducer(initialFacilityShiftHistoryState, (builder) => {
  builder
    .addCase(fetchFacilityShiftHistory.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchFacilityShiftHistory.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    })
    .addCase(fetchFacilityShiftHistory.rejected, (state, action) => {
      state.error = action.payload as string;
    });
});

const initialFacilityReportStatsState: IFacilityReportStatsState = {
  loading: false,
  data: null,
  error: null,
};

export const facilityReportStatsReducer = createReducer(initialFacilityReportStatsState, (builder) => {
  builder
    .addCase(fetchFacilityReportStats.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchFacilityReportStats.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    })
    .addCase(fetchFacilityReportStats.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});

const initialWorkerAttendanceState: IWorkerAttendanceState = {
  loading: false,
  data: null,
  error: null,
};

export const facilityWorkerAttendanceReducer = createReducer(initialWorkerAttendanceState, (builder) => {
  builder
    .addCase(fetchFacilityWorkerAttendance.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchFacilityWorkerAttendance.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    })
    .addCase(fetchFacilityWorkerAttendance.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});



const initialFacilityDashboardStatisticsState: IFacilityDashboardStatisticsState = {
  loading: false,
  data: null,
  error: null,
};

export const facilityDashboardStatisticsReducer = createReducer(initialFacilityDashboardStatisticsState, (builder) => {
  builder
    .addCase(fetchFacilityDashboardStatistics.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchFacilityDashboardStatistics.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    })
    .addCase(fetchFacilityDashboardStatistics.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});

const initialFacilityShiftStatusChartState: IFacilityShiftStatusChartState = {
  loading: false,
  data: null,
  error: null,
};

export const facilityShiftStatusChartReducer = createReducer(initialFacilityShiftStatusChartState, (builder) => {
  builder
    .addCase(fetchFacilityShiftStatusChart.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchFacilityShiftStatusChart.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    })
    .addCase(fetchFacilityShiftStatusChart.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});

const initialFacilityShiftCalendarState: IFacilityShiftCalendarState = {
  loading: false,
  data: null,
  error: null,
};

export const facilityShiftCalendarReducer = createReducer(initialFacilityShiftCalendarState, (builder) => {
  builder
    .addCase(fetchFacilityShiftCalendar.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchFacilityShiftCalendar.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    })
    .addCase(fetchFacilityShiftCalendar.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});

const initialFacilityAssignedWorkersState: IFacilityAssignedWorkersState = {
  loading: false,
  data: [],
  error: null,
};

export const facilityAssignedWorkersReducer = createReducer(initialFacilityAssignedWorkersState, (builder) => {
  builder
    .addCase(fetchFacilityAssignedWorkers.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchFacilityAssignedWorkers.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    })
    .addCase(fetchFacilityAssignedWorkers.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});

